import {
  DiscordLogoIcon,
  InfoCircledIcon,
  LockClosedIcon,
  Pencil2Icon,
  TwitterLogoIcon,
} from "@radix-ui/react-icons"
import { MediumLogo } from "@sundae/ui-toolkit"
import { initiateClient } from "client-theme"

import MyLogo from "./components/MyLogo"
import clientTranslations, { TClientTranslationType } from "./translations"

import "./styles.scss"

initiateClient<TClientTranslationType>({
  brand: {
    logos: {
      header: <MyLogo width={150} />,
      notFound: <MyLogo width={200} />,
    },
    buttons: {
      primary: {
        className: "!text-white !bg-[#0000fe] !bg-none !hover:bg-none",
      },
      secondary: {
        className: "!text-white !bg-[#0000fe] !bg-none !hover:bg-none",
      },
    },
  },
  includeClaimingFee: false,
  hideIntroText: true,
  clientNamespace: "glacier",
  clientTranslations,
  externalRoutes: {
    faq: "#",
    protocol: "#",
  },
  quickMenuPopover: (currentLocale) => [
    {
      title: clientTranslations[currentLocale].quickMenu.about,
      icon: <InfoCircledIcon />,
      link: "#",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.governance,
      icon: <Pencil2Icon />,
      link: "#",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.discord,
      icon: <DiscordLogoIcon />,
      link: "#",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.twitter,
      icon: <TwitterLogoIcon />,
      link: "#",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.medium,
      icon: <MediumLogo />,
      link: "#",
    },
    {
      title: clientTranslations[currentLocale].quickMenu.legal,
      icon: <LockClosedIcon />,
      link: "#",
    },
  ],
})
